
import { defineComponent, ref, onMounted } from 'vue'

import axios from 'axios'

import Animate from '@/components/Common/Animate.vue'

interface FacebookPost {
    id: string
    created: string
    message: string
    permalink: string
    picture: string
}

export default defineComponent({
    name: 'FacebookPosts',
    components: {
        Animate,
    },
    setup() {
        let facebookPosts = ref([] as FacebookPost[])
        const url =
            process.env.NODE_ENV === 'production'
                ? 'https://node.retailonly.se'
                : 'http://192.168.1.11:5500'

        const fetchFacebookPosts = async () => {
            const result = await axios.get(`${url}/facebookPosts?limit=20`)

            if (!result) return
            facebookPosts.value = result.data.data.filter(
                (post) => post.message
            )
        }

        onMounted(fetchFacebookPosts)

        return {
            facebookPosts,
        }
    },
})
